import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import whatwedoimage5 from "../../assets/images/WhatwedoImage5.png";
import whatwedo5 from "../../assets/images/Whatwedo/whatwedo5.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";

const WhatwedoContent = () => {

  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Box
      sx={{
        width: "100%",
        padding: "0rem 0rem",
        display: "flex",
        justifyContent: { xs: "start", md: "flex-start" },
        alignItems: "center",
        flexDirection: { xs: "column", md: "row" },
      }}
    >
      <Box
        sx={{
          width: { xs: "80%", sm: "55%", md: "40%" },
        }}
      >
        <Box
          sx={{
            width: { xs: "auto", md: "30rem" },
          }}
        >
          <LazyLoadImage
            src={isMdUp ? whatwedoimage5 : whatwedo5}
            effect="blur"
            width="100%"
            height="100%"
          />
        </Box>
      </Box>

      <Box
        sx={{
          width: { xs: "100%", md: "58%" },
          padding: "0 2rem 2rem 2rem",
        }}
      >
        <Typography
          component="div"
          sx={{
            color: "rgba(51, 51, 51, 1)",
            fontFamily: "Plus Jakarta Sans",
            marginTop: { xs: "1rem", md: "0rem" },
            fontSize: "1rem",
          }}
        >
          Our team of industry stalwarts specialize in functional as well as
          technical areas, such as:
        </Typography>

        <ul
          style={{
            listStyle: "none",
            paddingTop: "1rem",
            margin: 0,
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
            gap: "0.5rem",
          }}
        >
          {[
            "Data analytics",
            "Technology",
            "Brand",
            "Communication",
            "Media",
            "Digital",
            "Retail",
            "Innovation",
            "New Product Development",
            "Sales & Distribution",
            "Operations",
            "Retail Marketing",
            "Consumer Insights",
            "Innovation & Strategic Business Consulting",
            "Communication Testing",
            "Neuroscience",
            "Quantitative Research",
            "Qualitative Research",
            "Digital Transformations in Operations & Analytics",
          ].map((item, index) => (
            <li key={index}>
              <Typography
                component="div"
                sx={{
                  color: "rgba(51, 51, 51, 1)",
                  fontFamily: "Plus Jakarta Sans",
                  fontSize: "1rem",
                  display: "flex",
                  alignItems: "flex-start",
                }}
              >
                <span
                  style={{
                    color: "rgba(243, 107, 43, 1)",
                    fontWeight: "bold",
                    fontSize: "1.1rem",
                    marginRight: "0.5rem",
                  }}
                >
                  •
                </span>
                <span style={{ fontFamily: "Plus Jakarta Sans" }}>{item}</span>
              </Typography>
            </li>
          ))}
        </ul>
      </Box>
    </Box>
  );
};

export default WhatwedoContent;
